import { useModal } from 'providers/ModalProvider';
import { FinanceProvider } from '@honeybook/finance-components/dist/providers/FinanceProvider';
import { useGetAnalyticsCb } from 'lib/client/services/mixpanel/useAnalytics';
import { useToast } from '../providers/ToastProvider';
import getConfig from 'next/config';
import { AnalyticsProvider } from '@honeybook/finance-components/dist/providers/AnalyticsProvider';
import type { FinanceProviderProps } from '@honeybook/finance-components/dist/providers/provider.types';
import { useMemo } from 'react';
import type { ServerUIPreference } from '@honeybook/finance-components/dist/lib/UIPreferences.types';

export const FinanceExternalWrapper: React.FC<{
    appPath?: string;
    uiPreferences?: ServerUIPreference[] | false;
}> = props => {
    const { children, appPath } = props;
    const { openModal, closeModal, isOpen } = useModal();
    const toastProps = useToast();

    const modalOptions: FinanceProviderProps['modalOptions'] = useMemo(
        () => ({
            openModal: (_id, component) => openModal(component),
            closeModal,
            isOpen
        }),
        [closeModal, isOpen, openModal]
    );

    const {
        publicRuntimeConfig: { hbApiUrl, isProduction }
    } = getConfig();
    return (
        <FinanceProvider
            config={{ hbApiUrl, isProd: isProduction }}
            modalOptions={modalOptions}
            appPath={appPath}
            toastOptions={toastProps}
            uiPreferences={props.uiPreferences}
        >
            {children}
        </FinanceProvider>
    );
};

export const AnalyticsProviderWrapper: React.FC<{ appPath?: string }> = ({ children, appPath }) => {
    const trackCb = useGetAnalyticsCb();
    return (
        <AnalyticsProvider trackCb={trackCb} appPath={appPath}>
            {children}
        </AnalyticsProvider>
    );
};
